import type { DayOfWeek } from '@/shared/enums/DayOfWeekEnum'
import type { BranchShiftStatus } from '../enums/BranchShiftStatus'

export class BranchShiftDayTimeSlotEntity {
  id?: string
  startTime?: string | Date
  startTimeDayOfWeek?: DayOfWeek
  endTime?: string | Date
  endTimeDayOfWeek?: DayOfWeek
  status?: BranchShiftStatus
}
